import { Box, Typography, Button } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

const CARD_HEIGHT_DESKTOP = 420;

const caseUrls = [
  "https://youtu.be/rpE7QhXK024",
  "https://youtu.be/z3k_UyP5H_g",
  "https://youtu.be/zD5qNqvMN2g",
  "https://youtu.be/LkEQhyFdShE",
];

export default function CasesCards() {
  const { t } = useTranslation();
  const items = t("casesTiles.items", { returnObjects: true });

  return (
    <Box component="section" sx={{ bgcolor: "#CEFF1A" }}>
      <Box
        sx={{
          width: { xs: "100%", lg: "1440px" },
          mx: "auto",
          minHeight: { lg: CARD_HEIGHT_DESKTOP },
          display: "flex",
          alignItems: "flex-start",
          pt: { xs: 0, lg: 0 },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", lg: "1240px" },
            mx: "auto",
            px: { xs: 2, sm: 3 },
            py: { xs: 0, lg: 0 },
            display: "grid",
            gridTemplateColumns: {
              xs: "310px",
              md: "310px",
              lg: "repeat(4, 310px)",
            },
            justifyContent: { xs: "center", md: "center", lg: "space-between" },
            gap: { xs: 0, lg: "1px" },
            backgroundColor: "#CEFF1A",
          }}
        >
          {items.map((c, i) => (
            <Box key={`${c.title}-${i}`} sx={{ display: "contents" }}>
              <Box
                sx={{
                  width: { xs: 310, lg: "310px" },
                  height: { xs: 498, lg: `${CARD_HEIGHT_DESKTOP}px` },
                  bgcolor: "#2D2E2F",
                  color: "#ECEDF8",
                  display: "flex",
                  flexDirection: "column",
                  p: { xs: 3, md: 4 },
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: { xs: 0, lg: 0 },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "0px",
                    backgroundColor: "#CEFF1A",
                    transition: "height 160ms ease",
                  },
                  "&:hover::after": { height: "8px" },
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, flex: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#CEFF1A",
                      fontWeight: 800,
                      lineHeight: 1.1,
                      mb: 2,
                      letterSpacing: 0.5,
                    }}
                  >
                    <Trans components={{ bold: <Box key="b" component="strong" sx={{ fontWeight: 800 }} /> }}>
                      {c.title}
                    </Trans>
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      color: "#ECEDF8",
                      opacity: 0.95,
                      lineHeight: 1.6,
                      letterSpacing: 0.5,
                    }}
                  >
                    {c.body}
                  </Typography>

                  <Box sx={{ mt: "auto", pt: 3 }}>
                    <Button
                      component="a"
                      href={caseUrls[i]}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        width: "137px",
                        height: "46px",
                        borderRadius: "28px",
                        border: "1.5px solid #ECEDF8",
                        color: "#ECEDF8",
                        fontWeight: 800,
                        textTransform: "none",
                        letterSpacing: 0.3,
                        "&:hover": {
                          borderColor: "#FFFFFF",
                          backgroundColor: "transparent",
                          color: "#CEFF1A",
                        },
                      }}
                    >
                      {t("buttons.seeMore")}
                    </Button>
                  </Box>
                </Box>
              </Box>

              {i < items.length - 1 && (
                <Box
                  sx={{
                    display: { xs: "block", lg: "none" },
                    width: 310,
                    height: 1,
                    bgcolor: "#B5F000",
                    mx: "auto",
                  }}
                />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}